module.exports = __webpack_public_path__ + "static/img/2.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/2.png
// module id = JJq1
// module chunks = 0